import EthereumService from '@/services/ethereum'
import cookie from '@/utils/cookie'
import { getBase64, resizeImage, base64toBlob } from '@/utils/helper'
export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async getUserProfile () {
    const { data } = await this.kulapApi.getUserProfile()
    this.store.dispatch('setUser', data)
    return data
  }

  async updateUserProfile (user) {
    const { data } = await this.kulapApi.updateUserProfile(user)
    return data
  }

  async updateProfilePicture (file) {
    const base64 = await getBase64(file)
    const image = await resizeImage(base64)
    const blobImage = await base64toBlob(image)
    const formData = new FormData()
    formData.append('name', 'profilePicture')
    formData.append('file', blobImage)
    const { data } = await this.kulapApi.updateProfilePicture(formData)
    const oldCookie = JSON.parse(cookie.get('user'))
    oldCookie.profilePicture = `${data}?${Math.random()}`
    cookie.set('user', oldCookie)
    return data
  }

  async unlinkSocial (social) {
    const { data } = await this.kulapApi.unlinkSocial(social)
    return data
  }

  async generate2FACode () {
    const { data } = await this.kulapApi.getGenerate2FA()
    return data
  }

  async enable2FA (code) {
    const { data } = await this.kulapApi.putEnable2FA(code)
    return data
  }

  async disable2FA (code) {
    const { data } = await this.kulapApi.putDisable2FA(code)
    return data
  }
}



// WEBPACK FOOTER //
// ./src/pages/UserProfile/service.js